import { TableSchema } from '../metadata-schema';

export const dim_vs_vestiging: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_vs_vestiging",
	"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Instellingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek",
		"nl.topicus.cumlaude.metadata.table.BeheerderVestigingOverride"
	],
	"properties": {
		"vs_cos_brinvest": {
			"type": "array",
			"items": {
				"type": "string"
			},
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"vs_cos_brinvest_actief": {
			"type": "array",
			"items": {
				"type": "string"
			},
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"vs_d_geldig_va": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"vs_d_geldig_tot": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"vs_id_vestiging": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"vs_is_actief": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"vs_is_vo": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"vs_is_vso": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"vs_nm_vestiging": {
			"type": "string",
			"label": "Vestiging",
			"category": "School",
			"example": "Locatie CumLaude",
			"allowlist": {
				"beheer": true
			}
		}
	}
};
